import { clampDateToMidnight, startOfWeekMonday } from "./dateUtils";
import { dayKeyFromDate } from "./scheduleSettingsUtils";

export const SESSION_ANIMATION_TIMINGS = {
  createFadeInMs: 4000,
  moveFadeOutMs: 420,
  deleteFadeOutMs: 3000,
  updateHighlightMs: 8000,
  navigationSettleMs: 240,
  animationRetentionMs: 8000,
};

export function buildSessionAnimationCssVars(timings = SESSION_ANIMATION_TIMINGS) {
  return {
    "--session-create-fade-ms": `${Number(timings.createFadeInMs) || 700}ms`,
    "--session-move-fade-out-ms": `${Number(timings.moveFadeOutMs) || 420}ms`,
    "--session-delete-fade-out-ms": `${Number(timings.deleteFadeOutMs) || 420}ms`,
    "--session-update-highlight-ms": `${Number(timings.updateHighlightMs) || 1400}ms`,
  };
}

export function waitForMs(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, Math.max(0, Number(ms) || 0));
  });
}

export function isPlacementPatch(patch = {}) {
  const keys = ["start", "end", "dayKey", "tutorUid", "slotIdx", "blockId"];
  return keys.some((key) => Object.prototype.hasOwnProperty.call(patch, key));
}

export function applyPatchPreview(session, patch = {}) {
  if (!session) return null;
  const next = { ...session, ...patch };

  if (Object.prototype.hasOwnProperty.call(patch, "start")) {
    next.start = patch.start ? new Date(patch.start) : session.start;
  } else if (session?.start) {
    next.start = new Date(session.start);
  }

  if (Object.prototype.hasOwnProperty.call(patch, "end")) {
    next.end = patch.end ? new Date(patch.end) : session.end;
  } else if (session?.end) {
    next.end = new Date(session.end);
  }

  return next;
}

export function resolvePlacementTarget(sessionLike) {
  if (!sessionLike?.start) return null;
  const startDate = clampDateToMidnight(new Date(sessionLike.start));
  const dayKey = dayKeyFromDate(startDate);
  if (!dayKey) return null;

  return {
    date: startDate,
    dayKey,
    weekStart: startOfWeekMonday(startDate),
  };
}
